import React, { Component } from 'react'
import { connect } from 'react-redux'
import SearchWidget from 'components/SearchWidget'

const HomeActivityExtraNav = ({ dispatch }) => {
  return (
    <SearchWidget
      onSearch={s => {
        dispatch({
          type: 'home/activity',
          payload: {
            search: s
          }
        })
      }}
      onCancelSearch={() => {
        dispatch({
          type: 'home/activity',
          payload: {}
        })
      }}
    />
  )
}

const mapStateToProps = ({ location: { type } }) => ({ place: type })
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(
  HomeActivityExtraNav
)
